import { ArrowRight } from '@untitled-ui/icons-react/build/cjs';
import React from 'react';

interface IProps {
    text: React.ReactNode;
    icon?: React.ReactNode;
    isClickable?: boolean;
    onClick?: () => void;
}

const AiActionNotification = ({ text, isClickable, icon, onClick }: IProps) => (
    <div
        onClick={onClick}
        className={`rounded-full bg-utilityGray100 px-2 py-[3px] mx-auto w-fit !mt-4 ai-notification first:!mt-0 ${isClickable && 'hover:bg-gray200 cursor-pointer'} ${
            (icon || isClickable) && 'flex gap-x-1.5 items-center'
        } `}
    >
        {icon && icon}
        <p className={`text-gray500 text-[10px] leading-[14px] font-medium text-center`}>{text}</p>
        {isClickable && (
            <>
                <ArrowRight className="w-3.5 h-3.5 text-primary" />
            </>
        )}
    </div>
);
export default AiActionNotification;
